import React from 'react';

export const CenterLocation = () => (
  <g
    transform="matrix(49.059468,0,0,49.059468,0.14961413,0.49546399)"
    strokeWidth="0.02038343"
  >
    <path
      fill="#748498"
      strokeWidth="0.02038343"
      d="m 11,14 a 3,3 0 1 0 0,-6 3,3 0 0 0 0,6 z M 10.887,4.008 a 1,1 0 0 0 0.242,0 6.95,6.95 0 0 1 6.871,6.879 1,1 0 0 0 0,0.242 6.95,6.95 0 0 1 -6.88,6.87 1.001,1.001 0 0 0 -0.24,0 6.95,6.95 0 0 1 -6.872,-6.878 1,1 0 0 0 0,-0.242 6.95,6.95 0 0 1 6.879,-6.871 z m 0.102,-4.018 a 1,1 0 0 0 -0.985,1.014 v 1.059 a 8.944,8.944 0 0 0 -7.941,7.94 H 1.004 a 1,1 0 1 0 0,2 h 1.059 a 8.945,8.945 0 0 0 7.941,7.942 v 1.059 a 1,1 0 1 0 2,0 v -1.059 a 8.945,8.945 0 0 0 7.942,-7.941 h 1.058 a 1,1 0 1 0 0,-2 H 19.946 A 8.945,8.945 0 0 0 12.004,2.063 V 1.003 A 1,1 0 0 0 10.99,-0.01 Z"
    />
  </g>
);
